// console.log('custom.js');

$(function () {

  /*

  共通ヘッダー

  スクロールで、PCはメニュー表示(.js-topmenu)・SPはヘッダー縮小(.js-header)

  */

  $(window).scroll(function(){

    scroll = $(this).scrollTop();

    winW = $(window).width();

    if(winW > 960){

      target = $('.js-topmenu');

    }else{

      target = $('.js-header');

    }

    if(scroll >= 10){

      target.addClass('is-scroll');

    }else{

      target.removeClass('is-scroll');

    }

  });

  /*

  商品:SKUカート

  */

  // 開閉

  var skucart_scrollY = 0;

  $(document).on('click', '.js-skucart-open', function () {

    type = $(this).attr('data-type');

    target = $(this).parent('div').children('.js-skucart-wrap');

    skucart_scrollY = window.scrollY;

    // target.fadeIn(100);

    $('body').addClass('is-skucart-open');

    target.addClass('is-show');

    target.attr('data-type', type);

  }),

  $(document).on('click', '.js-skucart-close', function () {

    // $('body').removeClass('is-skucart-open');

    // $('html,body').scrollTop(skucart_scrollY);

    // $('.js-skucart-wrap').css('display', 'none');

    $('body').removeClass('is-skucart-open');

    $('html,body').scrollTop(skucart_scrollY);

    $('.js-skucart-wrap').removeClass('is-show');

  });

  // カート追加

  $('.js-skucart-addcart').on('click', function(){

    var formData = {

      'items': [{

      'id': $(this).data('variant-id'),

      'quantity': 1

      }]

    };

    fetch('/cart/add.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json'

      },

      body: JSON.stringify(formData)

    })

    .then(response => response.json())

    .then(data => {

      console.log('商品が追加されました:', data);

      return fetch('/cart.js');

    })

    .then(response => response.json())

    .then(cartData => {

      console.log('現在のカート情報:', cartData);

      console.log('現在のカート件数:', cartData.item_count);

      var quickCart = document.querySelector('.quick-cart');

      if (quickCart) {
        // Let Stiletto refresh its native quick cart and cart counters.
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));

        // Close the SKU selector before opening the drawer.
        $('body').removeClass('is-skucart-open');
        $('.js-skucart-wrap').removeClass('is-show');

        // Stiletto already intercepts the native cart icon and opens quick-cart.
        // Small delay gives its Ajax refresh time to complete.
        setTimeout(function () {
          var cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) {
            cartIcon.click();
          } else {
            window.location.href = '/cart';
          }
        }, 300);
      } else {
        // Original behaviour when the cart drawer option is disabled.
        window.location.href = '/cart';
      }

    })

    .catch(error => {

      console.error('エラー:', error);

    });

  });

});
